import { useSessionStorage } from 'react-use';
import { SourceListStateProvider } from './sourceListInterface';
import { useState } from 'react';

export function createSourceListState(): SourceListStateProvider {
    return {
        useState(context, item) {
            const [isExpanded, setIsExpanded] = useState<boolean>(false);
            const [activeId, setActiveId] = useState<string | null>(null);
            return {
                active: {
                    value: activeId,
                    onChange: setActiveId,
                },
                expanded: {
                    value: isExpanded,
                    onChange: setIsExpanded,
                },
            };
        },
    };
}
